import { useState, useMemo, useEffect } from "react";

// Paginación del lado del cliente sobre un arreglo ya cargado/filtrado.
export function useClientPaged(items, pageSize = 8) {
  const [page, setPage] = useState(1);
  const total = items.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  useEffect(() => { if (page > pages) setPage(1); }, [pages, page]);
  const pageRows = useMemo(() => items.slice((page - 1) * pageSize, page * pageSize), [items, page, pageSize]);
  return { pageRows, page, setPage, pages, total, pageSize };
}

export default useClientPaged;
